export default {
  // Default conversation items
  defaultConversations: {
    whatIsIt: 'What is it?',
    howToInstall: 'How to quickly install and import components?',
    newAGIInterface: 'New AGI hybrid interface',
  },
  
  // Group labels
  groups: {
    today: 'Today',
    previous: 'Previous',
  },
  
  // Error messages
  errors: {
    requestInProgress: 'The request is in progress, please wait until the request is completed.',
    requestSuspended: 'The request has been suspended.',
    requestFailed: 'The request failed, please try again!',
    planLimitReached: "You've reached your plan limit.",
    upgradeToAccessMore: 'Upgrade now to access more tasks or try tomorrow after 8:00 am.',
    failedToUpdateMessage: 'Failed to update message.',
    feedbackSubmitFailed: 'Failed to submit feedback.',
    cannotEditMessage: 'Cannot edit message: data format is incorrect or incomplete',
  },
  
  // Success messages
  success: {
    feedbackSubmitted: 'Feedback submitted.',
    messageUpdated: 'Message has been updated.',
  },
  
  // Button text
  buttons: {
    upgrade: 'Upgrade',
    startYourOwnTask: 'Start your own task',
  },
  
  // Tip text
  tips: {
    viewingTask: "You're viewing a task. Go ahead and try it yourself!",
    waiting: 'waiting...',
  },
  
  // Status text
  status: {
    error: 'Error',
  },
  
  // Operation hints
  operations: {
    refreshMessageContent: 'Refresh message content',
    editMessage: 'Edit message',
    likeMessage: 'Like message',
    dislikeMessage: 'Dislike message',
    renameSession: 'Rename session',
    deleteSession: 'Delete session',
  },
  
  // Modal titles
  modalTitles: {
    renameSession: 'Rename Session',
    deleteSession: 'Delete Session',
    feedback: 'Feedback',
  },
  
  // Input placeholders
  placeholders: {
    renameSession: 'Please enter new session name',
    feedbackReason: 'Please enter feedback reason',
  },
  
  // Confirmation messages
  confirmations: {
    deleteSession: 'Are you sure you want to delete this session?',
  },
  
  // Loading states
  loading: {
    loadingSessionMessages: 'Loading session messages...',
    loading: 'Loading...',
  },
  
  // Empty states
  empty: {
    noMessages: 'No messages',
    noSessions: 'No sessions',
  },
  
  // Time related
  time: {
    justNow: 'Just now',
    minutesAgo: 'minutes ago',
    hoursAgo: 'hours ago',
    daysAgo: 'days ago',
  },
  
  // File related
  files: {
    attachments: 'Attachments',
    otherAttachments: 'Other attachments',
    imageFile: 'Image file',
    documentFile: 'Document file',
  },
  
  // Session related
  session: {
    newSession: 'New Session',
    sessionName: 'Session Name',
    sessionId: 'Session ID',
    tempSession: 'Temporary Session',
  },
  
  // Message related
  message: {
    user: 'User',
    assistant: 'Assistant',
    system: 'System',
    messageId: 'Message ID',
    content: 'Content',
    role: 'Role',
    status: 'Status',
    feedback: 'Feedback',
    like: 'Like',
    dislike: 'Dislike',
  },
  
  // Chat bot types
  chatBotTypes: {
    dnaChatbot: 'DNA Chatbot',
    agentChatbot: 'Agent Chatbot',
    shareChatbot: 'Share Chatbot',
  },
  
  // Function tools
  tools: {
    functionTools: 'Function Tools',
    commandTools: 'Command Tools',
    action: 'Action',
    toolStart: 'Tool Start',
    toolEnd: 'Tool End',
    command: 'Command',
    done: 'Done',
  },
  
  // Main page related
  mainPage: {
    loading: 'Loading...',
    noActiveSession: 'No active session',
    userId: 'User ID',
    sessionList: 'Session List',
    token: 'Token',
  },
  
  // Chat bot configuration
  chatBotConfig: {
    chatbot: 'Chatbot',
    dnaChatbot: 'DNA Chatbot',
    shareChatbot: 'Share Chatbot',
  },
  
  // Feature toggles
  features: {
    showChatSider: 'Show Chat Sider',
    showChatWelcome: 'Show Chat Welcome',
    showChatTemplate: 'Show Chat Template',
  },
  
  // ChatList component related
  chatList: {
    // Button titles
    refresh: 'Refresh',
    copy: 'Copy',
    edit: 'Edit',
    like: 'Like',
    dislike: 'Dislike',
    
    // Message status
    copiedToClipboard: 'Copied to the clipboard.',
    copyFailed: 'Copy failed, please copy manually',
    copyFailedFallback: 'Copy failed, please copy manually.',
    
    // Welcome message
    welcomeMessage: 'Hi {firstName}, how can I help you achieve your marketing goals today?',
    
    // Prompts
    prompt1: 'Can you help me get 1,000 new users?',
    prompt2: 'Can you help me come up with viral content ideas for my brand?',
    prompt3: 'Can you help me create a social media post?',
    
    // Error messages
    unableToDisplayContent: 'Unable to display the content format.',
    
    // File related
    unknownFiles: 'Unknown files',
    
    // Header label
    head: 'AhaCreator',
  },
  
  // Editor related
  editor: {
    editPlaceholder: 'Edit the content here...',
  },

  // Sender (input) related
  chatSender: {
    errors: {
      fileTooLarge: 'File must be less than 10MB!',
      batchUploadFailed: 'Batch upload failed.',
      waitUpload: 'Please wait for the file to upload.',
    },
    messages: {
      fileRemoved: '{name} has been removed.',
      requestCancelled: 'The request has been cancelled.',
    },
    attachments: {
      dropTitle: 'Drop files here',
      description: 'Click or drag files to this area to upload (supports images, documents, and other formats)',
    },
    titles: {
      image: 'image',
    },
    placeholder: {
      input: 'Message...'
    },
  },

  // Sidebar related
  chatSider: {
    buttons: {
      startCampaign: 'Start a campaign',
      startTask: 'Start a task',
      viralIdeas: 'Viral ideas',
      headsDna: 'AhaCreator\'s DNA',
    },
    tooltips: {
      ongoingTask: 'You have an ongoing task; please start a new task later.',
    },
    labels: {
      taskHistory: 'Task history',
      newConversation: 'new conversation {number}',
    },
    menu: {
      rename: 'Rename',
      delete: 'Delete',
    },
    errors: {
      failedGetSessionId: 'Failed to get session id.',
    },
  },

  // Command tool related
  commandTool: {
    onboarding: {
      congratulations: 'Congratulations! You have successfully completed the onboarding process.',
      continue: 'Continue',
    },
  },

  // Template config related
  templateConfig: {
    categories: {
      marketResearch: 'Market research',
      marketingStrategy: 'Marketing strategy',
      contentCreation: 'Content creation',
      digitalMarketing: 'Digital marketing',
      offlineEvents: 'Offline events',
      brandManagement: 'Brand management',
    },
    marketResearch: {
      title: 'Market research',
      items: {
        conductResearch: 'Conduct market research',
        assessCompetitive: 'Assess competitive landscape',
        monitorSentiment: 'Monitor social media sentiment',
        gatherInsights: 'Gather customer insights',
        modelOpportunities: 'Model & validate market opportunities',
        developPersonas: 'Develop user personas',
      },
    },
    marketingStrategy: {
      title: 'Marketing strategy',
      items: {
        defineObjectives: 'Define marketing objectives',
        developMessages: 'Develop key messages',
        developOmnichannel: 'Develop omnichannel strategies',
        designBudget: 'Design budget allocation strategy',
        designMetrics: 'Design performance metrics',
      },
    },
    contentCreation: {
      title: 'Content creation',
      items: {
        developViralIdeas: 'Develop viral ideas',
        createSocialPosts: 'Create social media posts',
        createSeoBlogs: 'Create SEO blogs',
        writeWebsiteContent: 'Write website content & UX copy',
        generateImages: 'Generate marketing images',
        generateVideos: 'Generate marketing videos',
        generateVideoAds: 'Generate video ads',
        generateEmails: 'Generate emails',
      },
    },
    digitalMarketing: {
      title: 'Digital marketing',
      items: {
        generateSeoBlogs: 'Generate and publish SEO blogs',
        generateSocialPosts: 'Generate and publish social media posts',
        collaborateInfluencers: 'Collaborate with influencers',
        discoverLookalike: 'Discover lookalike influencers',
        vetInfluencers: 'Vet influencers based on requirements',
        collaborateAffiliates: 'Collaborate with affiliates to drive sales',
        findCustomers: 'Find potential customers',
        generatePrLeads: 'Generate PR media leads',
        leveragePaidAds: 'Leverage paid ads to amplify results',
      },
    },
    offlineEvents: {
      title: 'Offline events',
      items: {
        planEvents: 'Plan offline events',
      },
    },
    brandManagement: {
      title: 'Brand management',
      items: {
        developBrandImage: 'Develop brand image',
        developBrandVoice: 'Develop brand voice of tone',
      },
    },
  },

  // Share template related
  shareTemplate: {
    title: 'See what AhaCreator can help you achieve',
  },

  // Credits details modal related
  creditsDetailsModal: {
    title: 'Usage',
    columns: {
      date: 'Date',
      details: 'Details',
      taskChange: 'Task change',
    },
    plan: 'plan',
    buttons: {
      manage: 'Manage',
      upgrade: 'Upgrade',
    },
    labels: {
      tasks: 'Tasks',
      dailyFreeTasks: 'Daily free tasks',
    },
  },

  // Delete modal related
  deleteModal: {
    title: 'Delete task?',
    description: 'Are you sure you want to delete this task? This can\'t be undone.',
    buttons: {
      delete: 'Delete',
    },
    messages: {
      deleted: 'Deleted task.',
      failed: 'Failed to delete task.',
    },
    content: 'Are you sure you want to delete this task? This can’t be undone.'
  },

  // Campaign recommendation related
  campaignRecommendation: {
    title: 'Turn strategy into actions!',
    subtitle: 'Click \'Create Campaign\' now to see immediate results.',
    createCampaign: 'Create Campaign',
    loading: 'Loading...',
    errors: {
      missingFields: 'Missing required fields',
      createFailed: 'Failed to create campaign',
    },
  },

  // Need user input related
  needUserInput: {
    message: 'AhaCreator will continue the task after receiving your reply...',
  },

  // Feedback modal related
  feedbackModal: {
    title: 'Feedback',
    submit: 'Submit',
    feedbackOptions: {
      misunderstanding: 'Misunderstanding the question',
      inaccurate: 'Inaccurate',
      irrelevant: 'Irrelevant',
      tooGeneral: 'Too general',
      others: 'Others',
    },
    placeholder: '(Optional) Please share any comments or suggestions that you have to help us improve. We appreciate your feedback!',
  },

  // Function call tools related
  functionCallTools: {
    headDnaRetrieved: 'AhaCreator\'s DNA and long-term memory has been retrieved',
    thinking: 'thinking...',
    taskCompleted: 'The task is completed!',
    mustUseType: 'must use type',
    unknownTools: 'Unknown tools',
  },

  // Rename modal related
  renameModal: {
    title: 'Rename task',
    save: 'Save',
    placeholder: 'Input new chat task',
    errors: {
      emptyName: 'Session name cannot be empty',
      renameFailed: 'Failed to rename task.',
    },
    success: 'Renamed task.',
  },

  // Side bottom related
  sideBottom: {
    share: {
      title: 'Share AhaCreator with a friend',
      subtitle: 'Refer a friend, earn 4 tasks',
    },
    plan: {
      title: 'Plan',
      tasks: 'Tasks',
      manage: 'Manage',
      upgrade: 'Upgrade',
    },
  },

  // Wait list share modal related
  waitListShareModal: {
    title: 'Share AhaCreator with a friend',
    subtitle: 'Refer 2 friends and get',
    adCredits: 'ad credits',
    invitationCode: 'Invitation code',
    friendsInvited: 'Friends invited',
    share: 'Share',
    tooltip: 'Meet AhaCreator, world\'s first AI marketer.',
    placeholder: 'Enter invitee\'s email',
    send: 'Send',
    invitationSent: 'Invitation sent successfully',
    enterValidEmail: 'Please enter a valid email',
  },
};
